import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";
import {connect} from "react-redux";
import {realismSelector, modalSelector} from "../../selectors";
import Realism from "./Realism";
import {getRealism, resetGettingRealism} from "../../AC/realism";
import {toggleModal} from "../../AC/modal";
import withErrorBoundary from "../../decorators/withErrorBoundary";
import NoSsr from "@material-ui/core/NoSsr";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import {withStyles} from "@material-ui/core/styles";
import VisibilityIcon from "@material-ui/icons/VisibilityOutlined";
import classNames from "classnames";

const styles = () => ({
  button: {
    "backgroundColor": `#fff`,
    "color": `#333`,
    "boxShadow": `none`,
    "fontWeight": `normal`,
    "textTransform": `none`,
    "border": `1px solid`,
    "&:hover": {
      opacity: `.8`,
      backgroundColor: `#fff`,
      color: `#333`
    }
  }
});

class RealisticView extends PureComponent {
  static propTypes = {
    isModalOpen: PropTypes.bool,
    toggleModal: PropTypes.func,
    realism: PropTypes.object,
    getRealism: PropTypes.func,
    classes: PropTypes.object
  };
  toggleModal = () => {
    this.props.toggleModal(`realism`);
    resetGettingRealism();
  };
  showRealisticViews = () => {
    this.props.getRealism();
  };
  render() {
    const {realism, isModalOpen, classes} = this.props;
    return (
      <div className="realistic-view">
        <NoSsr>
          <Tooltip title="Посмотреть на реальном изделии">
            <Button
              variant="contained"
              onClick={this.showRealisticViews}
              color="primary"
              className={classNames(classes.button, `realistic-view__button`)}
            >
              <VisibilityIcon />
              <span style={{marginLeft: `5px`}}>Реалистичный просмотр</span>
            </Button>
          </Tooltip>
        </NoSsr>
        <Modal
          className="editor-modal"
          overlayClassName="editor-modal-overlay"
          isOpen={isModalOpen}
          onRequestClose={this.toggleModal}
        >
          <div className="realism-box">
            {realism.progress >= 0 && (
              <Realism progress={realism.progress} views={realism.views} />
            )}
          </div>
          <button className="editor-modal__close" onClick={this.toggleModal}>
            ×
          </button>
        </Modal>
      </div>
    );
  }
}

Modal.setAppElement(`body`);

const mapStateToProps = (state) => ({
  realism: realismSelector(state),
  isModalOpen: modalSelector(state, `realism`)
});

const mapDispatchToProps = {
  getRealism,
  toggleModal
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorBoundary(withStyles(styles)(RealisticView)));
